import { render } from "./CollectibleNewModalPopup.vue?vue&type=template&id=3a23d2a4&scoped=true"
import script from "./CollectibleNewModalPopup.vue?vue&type=script&lang=js"
export * from "./CollectibleNewModalPopup.vue?vue&type=script&lang=js"

import "./CollectibleNewModalPopup.vue?vue&type=style&index=0&id=3a23d2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a23d2a4"]])

export default __exports__